import React from 'react';
export function MissionBanner() {
  return <section className="relative w-full py-32 md:py-48 overflow-hidden flex items-center justify-center" data-id="element-101">
      {/* Background image — static (no bg-fixed; it triggers paint thrash on mobile) */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/jX26ZY5eWWG9raYTFwXAC4/69fbb0910394c98503758eba.png)'
    }} aria-hidden="true" data-id="element-102" />

      {/* Navy Overlay — keeps text legible without burying the photo */}
      <div className="absolute inset-0 z-0 bg-brand-navy/70" aria-hidden="true" data-id="element-103" />

      {/* Content */}
      <div className="container relative z-10 mx-auto px-4 max-w-4xl text-center" data-id="element-104">
        <h2 className="font-display text-white text-4xl md:text-6xl lg:text-7xl font-bold uppercase leading-[1.05] tracking-wide mb-6 md:mb-8" data-id="element-105">
          It's Not About <span className="text-brand-gold" data-id="element-106">Cap Rates.</span>
        </h2>
        <p className="font-display text-white/90 uppercase tracking-[0.2em] text-sm md:text-lg lg:text-xl" data-id="element-107">
          It's about your faith, your family, your freedom.
        </p>
      </div>
    </section>;
}